import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import DateInput from "../../../components/common/inputs/DateInput";
export default function TotalUserCustomerCountReportsFilter({ filterDataHandler }) {
  const { utils } = useSelector(utilsState);

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="w-full flex flex-col sm:flex-row gap-6">
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, from: e })}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, to: e })}
        />
        <div className="flex flex-col">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            نقش
          </label>
          <select
            onChange={(e) =>
              filterDataHandler({ page: 1, role: e.target.value })
            }
            id="role-select"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-200 ease-in-out dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value="">همه ی نقش ها</option>
            {utils
              ? utils.ROLES_VALUES.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item?.name}
                  </option>
                ))
              : null}
          </select>
        </div>
      </div>
    </div>
  );
}
